<template>
  <div class="container">
    <!-- 页面0 -->
    <div class="page0">
      <div class="content-wrapper">
        <!-- 左侧文字内容 -->
        <div class="text">
          <div class="title">
            <img src="../../static/images/title.png" alt="花颜" class="title-img"/>
          </div>
          <div class="subtitle">蜜语时光，暖心相伴</div>
        </div>
        <!-- 右侧图片 -->
        <div class="image">
          <img src="../../static/images/right.png" alt="Logo Overlay" />
        </div>
      </div>
    </div>

    <!-- 页面1 -->
    <div class="page1">
      <div class="title">邂逅附近的人</div>
      <div class="desc">高颜值真人互动 转角遇到爱</div>
      <div class="code">
        <img src="../../static/images/zz.png" alt="QR Code" />
      </div>
    </div>

    <!-- 页面2 -->
    <div class="page2">
      <div class="title">附近实时动态</div>
      <div class="desc">分享你的生活，参与TA的人生</div>
      <div class="code">
        <img src="../../static/images/dt.png" alt="QR Code" />
      </div>
    </div>

    <!-- 页面3 -->
    <div class="page3">
      <div class="title">立即下载</div>
      <div class="code">
        <img src="../../static/images/logo.png" alt="Logo" />
      </div>
      <div class="download">
        <img src="../../static/images/download.png" @click="download" alt="Download Android" />
<!--        <img src="../../static/images/download1.png" alt="Download iOS" />-->
      </div>
      <div class="beian">
        Copyright © 辽宁元意科技有限公司
        <a target="_blank" href="https://beian.miit.gov.cn">{{ beian }}</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'home',
  data () {
    return {
      url: 'http://asset.ncaicai.tech/app/hy/hy.apk'
    }
  },
  methods: {
    download () {
      window.location.href = this.url
    }
  },
  computed: {
    beian () {
      return '辽ICP备2023010987号-4A'
    }
  }
}
</script>

<style lang="less">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.container {
  width: 100%;
  overflow-x: hidden;
}

.page0 {
  //padding: 2rem;
}

/* 标题图片样式 */
.title-img {
  width: 230px;      /* 设置固定宽度 */
  height: auto;      /* 高度自适应保持比例 */
  display: block;    /* 去掉底部空白间隙 */
  margin-bottom: 1.7rem; /* 和 subtitle 间距，可调整 */
  margin-left: 10rem;
}

.content-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.text {
  flex: 1 1 40%;
  padding: 1rem;
  text-align: center;

  .title {
    font-size: 4rem;
    font-weight: bold;
  }

  .subtitle {
    font-size: 2.5rem;
    font-weight: bold;
    margin-top: 0.5rem;
  }
}

.image {
  flex: 1 1 50%;
  display: flex;
  justify-content: center;

  img {
    max-width: 100%;
    height: auto;
    object-fit: cover;
  }
}

.page1,
.page2,
.page3 {
  text-align: center;

  .title {
    font-size: 2.5rem;
    margin-bottom: 1rem;
    padding-top: 3rem;
  }

  .desc {
    font-size: 1.2rem;
    font-weight: bold;
    margin-bottom: 2rem;
  }

  .code img {
    max-width: 100%;
    height: auto;
  }
}

.page2 {
  background: linear-gradient(to bottom, #FFA5A7, #FF4E98, #FF84C8);
  color: #fff;
}

.page3 {
  .download img {
    width: 15rem;
    //margin: 0.5rem;
    margin: -4rem 4rem 9rem 4rem;
    cursor: pointer;
    padding-top: 6rem;
  }

  .beian {
    margin-top: 2rem;
    font-size: 1rem;
    color: #fff;
    background-color: #FF5EA1;
    padding: 1rem;
    line-height: 1.5;
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .content-wrapper {
    flex-direction: column;
    text-align: center;
  }

  .text,
  .image {
    flex: 1 1 100%;
  }

  .text .title {
    font-size: 2.5rem;
  }

  .text .subtitle {
    font-weight: bold;
    font-size: 1rem;
  }

  .page1 .title,
  .page2 .title,
  .page3 .title {
    font-weight: bold;
    font-size: 2rem;
  }

  .download img {
    width: 8rem;
  }
}

/* 页面0样式 */
.page0 {

  .content-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 1rem; /* 控制两块内容之间的间距 */
  }

  .text {
    flex: 1 1 40%;
    text-align: center;

    .title {
      //font-size: 4rem;
      font-weight: bold;
      margin-bottom: 0.5rem;
    }

    .subtitle {
      //font-size: 1.5rem;
      color: #000000;
    }
  }

  .image {
    flex: 1 1 50%;
    display: flex;
    justify-content: flex-end; /* 图片向左调整 */
    padding-right: 0rem; /* 添加额外的右边距控制位置 */

    img {
      max-width: 170%;
      height: auto;
      object-fit: cover;
    }
  }
}
/* 响应式调整 */
@media (max-width: 768px) {
  .content-wrapper {
    flex-direction: row; /* 保持左右排列 */
  }

  .text {
    flex: 1 1 50%; /* 左侧和右侧均分 */
    text-align: left; /* 保持左对齐，避免视觉怪异 */
    padding-left: 1rem;
  }

  .image {
    flex: 1 1 50%;
    justify-content: flex-end; /* 保持图片靠左调整 */
    padding-right: 0.5rem;

    img {
      max-width: 90%; /* 防止图片过大导致溢出 */
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/view/Index.vue